import { type LayoutPages } from '../../types';
import EmbeddedCardShell from '../../../components/embedded/CardShell';
import HostedDesktopAppInstallPage from '../../hosted/desktop/DesktopAppInstallPage';
import EmbeddedLoadingPage from '../shared/LoadingPage';
import EmbeddedSpinnerScreen from '../shared/SpinnerScreen';
import EmbeddedAppPickerPage from '../shared/AppPickerPage';
import EmbeddedAppPairingPage from '../shared/AppPairingPage';
import EmbeddedDonePage from '../shared/DonePage';
import EmbeddedDesktopAgentStartPage from './DesktopAgentStartPage';
import EmbeddedDesktopWaitingPage from './DesktopWaitingPage';
import EmbeddedDesktopAbortPage from './DesktopAbortPage';

/** The embedded card, inline in the website's page, on tablets and computers. */
export const embeddedDesktopPages: LayoutPages = {
  Shell: EmbeddedCardShell,
  // The app list's placeholder tiles, then a spinner once an app is chosen.
  Loading: EmbeddedLoadingPage,
  Init: EmbeddedSpinnerScreen,
  Auth: EmbeddedSpinnerScreen,
  AppPicker: EmbeddedAppPickerPage,
  AgentStart: EmbeddedDesktopAgentStartPage,
  AppPairing: EmbeddedAppPairingPage,
  WaitingForPresentation: EmbeddedDesktopWaitingPage,
  Done: EmbeddedDonePage,
  Abort: EmbeddedDesktopAbortPage,
  // Only reached through ?app= on a top-level page, never inside the iframe.
  AppInstall: HostedDesktopAppInstallPage,
};
